<template>
  <CommonChipsGroup
    :class="page"
    :active="activeChip"
    :items="[
      {
        key: 'in-the-media',
        label: $t('aboutUs.link.inTheMedia'),
        redirectTo: '/about-us/in-the-media',
        iconURL: '/icons/paper.svg',
      },
      {
        key: 'awards',
        label: $t('aboutUs.link.awards'),
        redirectTo: '/about-us/awards',
        iconURL: '/icons/trophy.svg',
      },
      {
        key: 'partners',
        label: $t('aboutUs.link.partners'),
        redirectTo: '/about-us/partners',
        iconURL: '/icons/handshake.svg',
      },
    ]"
    size="large"
  />
</template>

<script setup lang="ts">
import type { ChipsGroupItem } from "~/components/common/ChipsGroup.vue";
const props = defineProps({
  active: {
    type: String,
    default: null,
  },
  page: {
    type: String,
    default: null,
  },
});

const activeChip = ref<ChipsGroupItem["key"]>(props.active);
</script>

<style>
.chips-group.about-us > * {
  @apply w-full md:w-auto px-6 md:px-0 mb-4 md:mb-0;
}
.chips-group.about-us a.chip {
  @apply justify-center;
}
</style>
